<template>
  <div class="layout">
    <div
      style="display: flex; gap: 10px; align-items: center; margin-bottom: 10px"
    >
      <img src="@/assets/images/icon/RFID.png" alt="RFID" height="50px" />
      <h1 style="font-weight: 800">Tag Log</h1>
    </div>
    <div style="display: flex; gap: 10px">
      <div class="m-card">
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 10px;
            align-items: center;
          "
        >
          <div
            style="
              font-size: 1.25rem;
              font-weight: 700;
              color: var(--text-color-2);
            "
          >
            Tag List Page 1
          </div>
          <div style="display: flex; gap: 5px; align-items: center">
            <div>
              <vs-tooltip text="Export XLSX" position="top">
                <vs-button
                  radius
                  class="mr-2"
                  color="var(--text-color-2)"
                  type="flat"
                  @click="exportXLSX(taglog1)"
                  icon="cloud_download"
                ></vs-button
              ></vs-tooltip>
            </div>
            <div
              style="
                background: #d4221c;
                color: #fff;
                padding: 5px 10px;
                border-radius: 50px;
                font-weight: 700;
                cursor:pointer;
              "
              @click="removeAll(taglog1)"
            >
              Remove All
            </div>
          </div>
        </div>
        <b-table-simple class="table_waterpump" responsive="sm">
          <b-thead class="table_header">
            <b-tr align="center" class="bgHeader">
              <b-th></b-th>
              <b-th>Timestamp</b-th>
              <b-th>Tag Name</b-th>
              <b-th>EQC</b-th>
              <b-th>RSSI</b-th>
              <b-th>Serial No.</b-th>
              <b-th>Count</b-th>
            </b-tr>
          </b-thead>
          <b-tbody style="color: var(--text-color)">
            <b-tr v-for="i in taglog1" :key="i">
              <b-td align="center">
                <vs-button
                  color="danger"
                  type="flat"
                  icon="remove"
                  @click="removeItem(i)"
                  >remove</vs-button
                >
              </b-td>
              <b-td align="center">{{ i.timestamp }}</b-td>
              <b-td align="center">{{ i.name }}</b-td>
              <b-td align="center">{{ i.epc }}</b-td>
              <b-td align="center">{{ i.rssi }} </b-td>
              <b-td align="center">{{ i.serial }}</b-td>
              <b-td align="center">{{ i.count }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <!-- <vs-table :data="taglog">
        <template slot="thead" class="bgHeader">
          <vs-th> </vs-th>
          <vs-th> Timestamp </vs-th>
          <vs-th> Tag Name </vs-th>
          <vs-th> EQC </vs-th>
          <vs-th> RSSI </vs-th>
          <vs-th> Serial No. </vs-th>
          <vs-th> Count </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].username">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].id">
              {{ data[indextr].website }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table> -->
      </div>
      <div class="m-card">
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 10px;
            align-items: center;
          "
        >
          <div
            style="
              font-size: 1.25rem;
              font-weight: 700;
              color: var(--text-color-2);
            "
          >
            Tag List Page 2
          </div>
          <div style="display: flex; gap: 5px; align-items: center">
            <div>
              <vs-tooltip text="Export XLSX" position="top">
                <vs-button
                  radius
                  class="mr-2"
                  color="var(--text-color-2)"
                  type="flat"
                  @click="exportXLSX(taglog2)"
                  icon="cloud_download"
                ></vs-button
              ></vs-tooltip>
            </div>
            <div
              style="
                background: #d4221c;
                color: #fff;
                padding: 5px 10px;
                border-radius: 50px;
                font-weight: 700;
                cursor:pointer;
              "
              @click="removeAll(taglog2)"
            >
              Remove All
            </div>
          </div>
        </div>
        <b-table-simple class="table_waterpump" responsive="sm">
          <b-thead class="table_header">
            <b-tr align="center" class="bgHeader">
              <b-th></b-th>
              <b-th>Timestamp</b-th>
              <b-th>Tag Name</b-th>
              <b-th>EQC</b-th>
              <b-th>RSSI</b-th>
              <b-th>Serial No.</b-th>
              <b-th>Count</b-th>
            </b-tr>
          </b-thead>
          <b-tbody style="color: var(--text-color)">
            <b-tr v-for="i in taglog2" :key="i">
              <b-td align="center">
                <vs-button
                  color="danger"
                  type="flat"
                  icon="remove"
                  @click="removeItem(i)"
                  >remove</vs-button
                >
              </b-td>
              <b-td align="center">{{ i.timestamp }}</b-td>
              <b-td align="center">{{ i.name }}</b-td>
              <b-td align="center">{{ i.epc }}</b-td>
              <b-td align="center">{{ i.rssi }} </b-td>
              <b-td align="center">{{ i.serial }}</b-td>
              <b-td align="center">{{ i.count }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <!-- <pre>{{taglog[1]}}</pre> -->
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx"; // import xlsx

export default {
  components: {},
  computed: {},
  data() {
    return {
      headerName: "RFID Log",
      dataExport: [],
      taglog: [[], []],
      taglog1: [],
      taglog2: [],
    };
  },
  mounted() {
    this.$WSS.connect("duo-roof");
    this.$WSS.emit("duo-roof", "message");
    this.$WSS.on("connect", () => {
      // client.on('sky-roof',()=>{
      console.log("socket id", this.$WSS.socket().id);
      // })
      // console.log(client);
      // client.on("sky-roof", (messageNew) => {
      //   console.log(
      //     "messageNew",
      //     messageNew,
      //     this.$moment().format("HH:mm:ss")
      //   );
      //   this.taglog = messageNew.message;
      // });
    });
    this.$WSS.on("connect_error", (err) => {
      console.log(`connect_error due to ${err.message}`);
      console.log(err);
      console.log(this.$WSS.socket());
        setTimeout(() => {
      this.$WSS.socket().auth.token = this.$session.get("accessToken");
      this.$WSS.socket().connect();
  }, 5*1000);
    });
    this.$WSS.on("duo-roof", (messageNew) => {
      console.log("messageNew", messageNew, this.$moment().format("HH:mm:ss"));
      // this.taglog = messageNew.message;
      let data = [[], []];
      for (let index = 0; index < messageNew.message.length; index++) {
        const element = messageNew.message[index];
        data[element.antenna - 1].push(element);
      }
      this.taglog1 = data[0];
      this.taglog2 = data[1];
    });
    this.$WSS.on("duo-roof-del", (messageNew) => {
      console.log("messageNew", messageNew, this.$moment().format("HH:mm:ss"));
      if (messageNew.message == "delete successfully") {
        this.$vs.notify({
          title: "Remove Success",
          text: "You deleted successfully",
          color: "success",
          position: "top-center",
          icon: "done",
          time: 5000,
        });
      } else {
        this.$vs.notify({
          title: "Remove Failed",
          text: "You deleted Failed",
          color: "danger",
          position: "top-center",
          icon: "clear",
          time: 5000,
        });
      }
    });
    this.$WSS.on("duo-roof-del-all", (messageNew) => {
      console.log("messageNew", messageNew, this.$moment().format("HH:mm:ss"));
      if (messageNew.message == "delete all successfully") {
        this.$vs.notify({
          title: "Remove All Success",
          text: "You remove all successfully",
          color: "success",
          position: "top-center",
          icon: "done",
          time: 5000,
        });
      } else {
        this.$vs.notify({
          title: "Remove All Failed",
          text: "You remove all Failed",
          color: "danger",
          position: "top-center",
          icon: "clear",
          time: 5000,
        });
      }
    });
  },
  beforeDestroy() {
    console.log("disconnect");
    // this.$WSS.emit("sky-roof-dis","disconnect");
    this.$WSS.disconnect();
  },
  methods: {
    getdatalog() {},
    exportXLSX(item) {
      const dataWS = XLSX.utils.json_to_sheet(item);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export" + this.headerName + ".xlsx");
      // this.dataExport = [];
      // this.dataActive = "";
    },
    removeItem(item) {
      console.log("remove item", item.epc);
      this.$WSS.emit("duo-roof-del", item.epc);
    },
    removeAll(item) {
      console.log("remove All",item);
      this.$WSS.emit("duo-roof-del-all", item[0].antenna);
    },
  },
};
</script>

<style lang="scss" scoped>
.bgHeader {
  background: #32c040;
  color: #ffffff;
  /* font-size: 0.78rem; */
}
</style>